import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing a commute trip icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <CommuteTripIcon width={12} />
 */
const CommuteTripIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M19.745 8.968c-1.809-1.836-4.309-2.972-7.073-2.972s-5.264
            1.137-7.075 2.973c-1.811 1.837-2.931 4.375-2.931 7.177 0 2.805 1.121
            5.344 2.935 7.181 1.809 1.836 7.072 6.015 7.072 6.015s5.265-4.181
            7.076-6.019c1.809-1.837 2.931-4.376 2.931-7.179-0.001-2.803-1.123-5.34-2.935-7.177zM12.535
            23.791c-4.236 0-7.671-3.484-7.671-7.783s3.436-7.783 7.671-7.783c4.239
            0 7.672 3.483 7.672 7.783 0 4.299-3.433 7.783-7.672 7.783z`}
        />
        <path d="M13.715 18.64h0.001v-0.001z" />
        <path
            d={`M18.232 15.443c-0.132 0-0.265-0.047-0.371-0.143l-5.187-4.668-5.187
            4.669c-0.228 0.205-0.58 0.187-0.785-0.041s-0.187-0.58 0.041-0.785l5.56-5.003c0.211-0.191
            0.532-0.191 0.743 0l5.559 5.003c0.229 0.205 0.247 0.557 0.041 0.785-0.112 0.121-0.263
             0.183-0.415 0.183z`}
        />
        <path
            d={`M12.657 11.552l-4.448 3.891 0.001
            5.003h5.56v-4.445h2.223v4.445h1.109v-5.003l-4.445-3.891zM11.544
            18.225h-2.223v-2.223h2.223v2.223z`}
        />
        <path
            d={`M27.387 4.605c-1.203-1.203-2.863-1.948-4.697-1.948s-3.496
            0.745-4.699 1.949c-0.333 0.333-0.629 0.705-0.888 1.104 0.351 0.143
            0.693 0.303 1.029 0.481 0.997-1.461 2.673-2.421 4.575-2.421 3.060
            0 5.54 2.484 5.54 5.549 0 2.615-1.807 4.8-4.237 5.388 0.060 0.475
            0.093 0.955 0.093 1.44 0 0.237-0.009 0.473-0.024 0.708 1.115-0.9
            2.604-2.131 3.308-2.836 1.204-1.208 1.947-2.872
            1.947-4.709s-0.744-3.501-1.947-4.705z`}
        />
        <path
            d={`M22.697 7.24v-1.251l-2.501 1.251v0.384c0.205
            0.177 0.407 0.36 0.6 0.553 0.14 0.14 0.276 0.285 0.407
            0.431v-0.36h1.112v1.112h-0.492c0.497 0.657 0.917 1.36
            1.256 2.1v-1.023h1.101v2.223h1.020v-6.671l-2.503 1.251zM24.191
            9.36h-1.111v-1.112h1.112v1.112z`}
        />
    </SvgIcon>
)

CommuteTripIcon.defaultProps = defaultProps

export { CommuteTripIcon }
